export const SET_CONFIGURATIONS = 'garage/SET_CONFIGURATIONS';

export const SET_LOADED_CONFIGURATION = 'garage/SET_LOADED_CONFIGURATION';

export const REMOVE_CONFIGURATION = 'garage/REMOVE_CONFIGURATION';

export const CLEAR_LOADED_CONFIGURATION = 'garage/CLEAR_LOADED_CONFIGURATION';

export const SET_SAVING = 'garage/SET_SAVING';
